<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_dr1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('authorization_driver_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('authorization_driver_updateMerchSignQuery_button')"
          @click="updateMerchSignQuery"
        >
          批量更新授权
        </el-button>
        <el-button
          v-if="getLimit('authorization_driver_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      highlight-current-row
      highlight-hover-row
      show-overflow
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      sort-config.remote
      align="center"
      export-config
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="name" title="名字" min-width="150" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.name" placeholder="名字" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="phone" title="手机" min-width="200" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.phone" placeholder="手机" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="identificationNumber"
          title="身份证号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.identificationNumber"
            placeholder=""
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'authStatus')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.authStatusOptions"
              :key="item.value + 'authStatus'"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="车牌号"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadStatus"
          title="车辆负载状态"
          min-width="130"
          :formatter="
            ({ cellValue }) =>
              formatterField({ cellValue }, 'vehicleLoadStatus')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleLoadStatus"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.vehicleLoadStatusOptions"
              :key="item.value + 'vehicleLoadStatus'"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="teamName"
          title="车队名称"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.teamName"
            placeholder="车队名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverType"
          title="实际承运人类型"
          min-width="180"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'driverType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.driverType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.driverTypeOptions"
              :key="item.value + 'driverType'"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchSign"
          title="网商授权状态"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'merchSign')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.merchSign"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.merchSignOptions"
              :key="item.value + 'merchSign'"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchSignType"
          title="授权方式"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'merchSignType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.merchSignType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.merchSignTypeOptions"
              :key="item.value + 'merchSignType'"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="merchantId"
          title="网商商户号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.merchantId"
            placeholder="网商商户号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="openBalancePay"
          title="是否开通余额支付权限"
          min-width="200"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'openBalancePay')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.openBalancePay"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.openBalancePayOptions"
              :key="item.value + 'openBalancePay'"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="150px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('authorization_driver_detail_button')"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="code => onShowModel(scope.row.partyCode)"
            >
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('authorization_driver_offlineAuthorization_button') &&
                (scope.row.merchSign == 0 ||
                  (scope.row.merchSignType == 1 && scope.row.merchSign == 3))
            "
            effect="dark"
            content="线下授权"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="OfflineAuthorization(scope.row.partyCode)"
            >
              <i class="el-icon-thumb" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- 新增，编辑和详情公用一个组件和弹框 -->
    <vxe-modal
      v-model="modelEditFlag"
      :title="modalTitle"
      width="80%"
      height="600"
      resize
    >
      <prodMerchRecord
        ref="EditRef"
        :parent-data="parentData"
        @onHideModel="onHideModel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import prodMerchRecord from "./components/prodMerchRecord.vue";
import {
  signOffline,
  updateMerchSignQuery,
  driverMerchantList
} from "@/api/InternetBanking";

export default {
  name: "AuthorizeManagementList",
  components: {
    prodMerchRecord
  },
  data() {
    return {
      /**
       * data 中只定义变量，赋值放在 created() 中
       */
      loading: false,
      tableData: [],
      parentData: {},
      modelEditFlag: false,
      modalTitle: "编辑",
      exportObj: {
        exportUrl:
          "/ntocc-tms-api/mybankMerchantprodMerch/exportMerchantList4Excel", //导出接口
        name: "实际承运人授权"
      },
      listQuery: {
        exportType: 0,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
      // Pagingconf: []
    };
  },

  created() {
    /**
     * 下拉选项用“parentData”存放，便于向子组件传递
     */
    this.parentData.authStatusOptions = [
      { label: "未审核", value: 0 },
      { label: "审核中", value: 1 },
      { label: "审核未通过", value: 2 },
      { label: "审核通过", value: 3 }
    ];
    this.parentData.vehicleLoadStatusOptions = [
      { label: "空载", value: 0 },
      { label: "负载", value: 1 }
    ];
    this.parentData.merchSignOptions = [
      { label: "待授权", value: 0 },
      { label: "授权中", value: 1 },
      { label: "已授权", value: 2 },
      { label: "授权失败", value: 3 }
    ];
    this.parentData.merchSignTypeOptions = [
      { label: "未授权", value: 0 },
      { label: "线上", value: 1 },
      { label: "线下", value: 2 }
    ];
    this.parentData.openBalancePayOptions = [
      { label: "否", value: 0 },
      { label: "是", value: 1 }
    ];
    this.parentData.driverTypeOptions = [
      { label: "独立实际承运人", value: 0 },
      { label: "车队实际承运人", value: 2 }
    ];
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        driverMerchantList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.loading = false;
          resolve();
        });
      });
    },
    updateMerchSignQuery() {
      const checkedRowArray = this.$refs.xTable.getCheckboxRecords();
      let codes = checkedRowArray.map(item => item.code).join(",");
      this.$confirm("确认进行批量更新授权操作？").then(_ => {
        const rLoading = this.openLoading();
        updateMerchSignQuery({ codes })
          .then(response => {
            this.$message({ message: response.msg, type: "success" });
          })
          .finally(() => {
            this.$refs.xTable.clearCheckboxRow();
            this.findList();
            rLoading.close();
          });
      });
    },
    // 翻译
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 展示弹框
    onShowModel(code) {
      if (code) {
        this.$refs.EditRef.getInfo(code, "driver");
      }
      this.modelEditFlag = true;
    },
    // 隐藏弹框
    onHideModel() {
      this.modelEditFlag = false;
      this.findList();
    },
    OfflineAuthorization(partyCode) {
      this.$confirm("确定进行线下授权吗？")
        .then(_ => {
          signOffline({ partyCode }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    }
  }
};
</script>
